import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../styles/lib/utils';
import { GridContext } from '../Grid';

const gridCellTextVariants = cva(
  'font-noto text-grey-90 font-normal text-xs overflow-hidden text-ellipsis break-words',
  {
    variants: {
      variant: {
        default: '',
        numeric: 'font-noto-mono',
      },
      lineClamp: {
        1: 'line-clamp-1 break-all!',
        2: 'line-clamp-2',
        3: 'line-clamp-3',
      },
    },
    defaultVariants: {
      variant: 'default',
      lineClamp: 1,
    },
  },
);

function GridCellText({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof gridCellTextVariants> & { asChild?: boolean }) {
  const gridContext = React.useContext(GridContext);
  const effectiveSpacing = gridContext.spacing || 'cozy';

  const lineClamp = effectiveSpacing === 'comfy' ? 2 : effectiveSpacing === 'roomy' ? 3 : 1;

  return (
    <span
      data-slot="grid-cell-text"
      className={cn(gridCellTextVariants({ variant, lineClamp, className }))}
      {...props}
    />
  );
}

export { GridCellText };
